var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionMarkInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5a10.5 10.5 0 1 1 0-21 10.5 10.5 0 0 1 0 21m0 1.5a12 12 0 1 0 0-24 12 12 0 0 0 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.9 8.7.3.3h1.3q.4 0 .4-.3.2-1.6 2-1.7c1 0 2 .5 2 1.7 0 1-.6 1.4-1.5 2q-1.7 1.1-1.7 3v.4l.3.4h1.3l.3-.4v-.2c0-1 .4-1.4 1.6-2.2.9-.7 1.8-1.5 1.8-3 0-2.4-1.9-3.4-4-3.4-1.9 0-4 .8-4.1 3.4m2.3 8.6q.1 1.3 1.5 1.4 1.6-.1 1.6-1.4-.1-1.3-1.6-1.4-1.4.1-1.5 1.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMarkInCircle);
export default ForwardRef;